import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as types from './types';


export const getTeamList = createApiAction(
  types.TEAMLIST_GET,
  (payload) => api.getTeams(payload),
);

export const removeTeam = createApiAction(
  types.TEAM_REMOVE,
  (payload) => api.removeTeam(payload).then(() => payload.id), // API doesn't return ID of deleted item, so we need to return it here
);

export const createTeam = createApiAction(
  types.TEAM_CREATE,
  (payload) => api.createTeam(payload),
);

export const autocompleteGetTeams = createApiAction(
  types.AUTOCOMPLETE_TEAMS_GET,
  (payload) => api.getTeams(payload),
);

export const autocompleteGetOwnTeams = createAction(types.AUTOCOMPLETE_TEAMS_GET_OWN);

export const assignTeamToGroup = createApiAction(
  types.ASSIGN_TEAM_TO_GROUP,
  ({ groupId, teamId }) => api.assignTeamToGroup(teamId, groupId)
    .then(() => ({ groupId, teamId }))
    .catch((err) => {
      /* eslint-disable no-param-reassign */
      err.groupId = groupId;
      err.teamId = teamId;
      throw err;
    }),
);

export const getOrganizationTeamsUsageCSV = createApiAction(
  types.GET_ORGANIZATION_TEAMS_USAGE_CSV,
  (payload, meta, dispatch) => (
    api.getOrganizationTeamsUsageCSV(payload)
      .catch(() => dispatch(notificationActions.notifyDanger('Something went wrong with CSV creation')))
  ),
);
